import { Component, OnInit } from '@angular/core';
import { ReceiptService } from '../receipt.service';
import { ReceiptItemService } from '../receipt-item.service';
import { Receipt } from '../receipt'; 
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/primeng';
import { GlobalDataService } from '../../../../services/global-data.service';
import { Router } from '@angular/router';
import {DialogModule} from 'primeng/primeng';
// import {ConfirmDialogModule} from 'primeng/primeng';
// import {ConfirmationService} from 'primeng/primeng';

export interface Pagination {
  current_page?: number;
  first_item?: number; 
  first_page_url?: string;
  last_item?: number;
  last_page?: number; 
  last_page_url?: string;
  next_page_url?: string;
  per_page?: number;
  prev_page_url?: string;
  total?: number; 
} 

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.css'],
  providers: [ReceiptService,ReceiptItemService]
})
export class ReceiptComponent implements OnInit {

	receiptCart: Receipt[] = [];
  receiptCartServer: any[]= [];
  pagination: Pagination;

  redactionDescription:string="";

  invoice_number: any;
  loading:boolean = true;
  loadingCartServer:boolean = true;

  display: boolean = false;
  messageDisplay:boolean = false;
  deleteIndex: any;
  selectStoreDialogVisible:boolean = false;
  _button_caption: string = "Сохранить";
  msgs: Message[] = [];

  store: any;
  stores: any=[];
  storeDropdownDisable:boolean = false;
  storeButtonDisable:boolean = false;

  searchColumn: any = [];
  searchFilter: any = [];



  constructor(
    private receiptService: ReceiptService,
    private receiptItemService: ReceiptItemService,
    public global: GlobalDataService,
    private router: Router
    ) {

           this.stores = this.global.user.stores.map(function(value){return {label: value.name, value: {id: value.id, name: value.name}}});
      }

  ngOnInit() {
     

       this.fillSearchColumn();

       this.pagination = {  
              current_page: 1,
              per_page:     1,
              last_page:    1
       }

        this.onLoad();
        this.loadReceiptServerByFilter();
  }


  loadReceiptServerByFilter(filter=[],page: number = 1){
      this.loadingCartServer = true;
      this.receiptService.getReceiptByFilter(filter,page).subscribe(response=>{ this.pagination = response['pagination'] || {current_page: 1,per_page: 1,last_page: 1};this.receiptCartServer = response['data'] ; this.loadingCartServer = false;})
  }

  fillSearchColumn() {
    this.searchColumn=[];
    this.searchColumn.push({ label: "Номер", value: { column: "invoice_number", type: "textbox" } });
    this.searchColumn.push({ label: "Дата начала", value: { column: "date_start", type: "calendar"} });
    this.searchColumn.push({ label: "Дата конца", value: { column: "date_finish", type: "calendar"} });
    this.searchColumn.push({ label: "Склад", value: { column: "store_id", type: "dropdown",value: this.global.user.stores.map(value => {
      return { label: value.name, value: { value: value.id, label: value.name } };
    }) } });
  }
  setFilter(data){
    this.searchFilter=data;
    this.loadReceiptServerByFilter(this.searchFilter, 1);
  }
  getColor(statusId: any) {
    switch (+statusId) {
      case 0:
        return "#a5a4a4";
      case 2:
        return "orange";
      case 3:
        return "#2185d0";
      case 4:
        return "#26ea53";
      case 5:
          return "#AEADAD";
      case -1:
        return "#db2828";
    }
  }

  showRedactionDiscription(description: string){
    this.redactionDescription = description;
  }

  onLoad(){  
    this.loading = true;
    if(localStorage.getItem('receipts')){
            this.receiptCart = JSON.parse(localStorage.getItem('receipts'));
            this.receiptCart = this.receiptCart.map((value,index)=>{value.index=index; return value;});
    }
    this.loading = false;
  }

    open(index){
      console.log("open"+index)
         this.router.navigate(['/dashboard/receipt-items/',index]);
    }


      showPage(id: any){
        this.router.navigate(['/dashboard/receipt-list-items/',id]);
      }
 
  save(){
     localStorage.setItem('receipts',JSON.stringify(this.receiptCart));
  }

  delete(index: number):void{
      this.messageDisplay = true;
      this.deleteIndex = index;
  }  

  OnAgreeDelete(){
      this.receiptCart.splice(this.deleteIndex,1);
      this.deleteIndex=null;
      this.messageDisplay = false;
      this.save();
      this.onLoad();
  }

  OnDegreeDelete(){
      this.messageDisplay = false;
  }





  loadSelectStoreDialog(){
    this.storeDropdownDisable=false;
    this.selectStoreDialogVisible = true;
    this.storeButtonDisable = true;
   
    if(this.stores.length==1){
        this.storeDropdownDisable=true;
        this.storeButtonDisable = false;
        this.store = this.stores[0].value;
    }
  }

 add():void{
   this.loadSelectStoreDialog();
 }

 onChange(event){
    this.storeButtonDisable = false; 
    this.store = event.value;
 }


 onNext(){
     this.receiptCart.push({
                     index: this.receiptCart.length,
                     invoice_number: (+this.receiptCart.length>0 ? this.receiptCart[this.receiptCart.length-1].invoice_number+1 : 1),
                     surcharge_percent: 0,
                     store:  this.store,
                     must_total_base: 0,
                     created_at: new Date().toISOString().slice(0,10), 
                     created_by: {id: this.global['user']['id'], full_name: this.global['user']['contact']['full_name']},
                     item: []
                  });
     this.save(); 
     this.router.navigate(['/dashboard/receipt-items/',this.receiptCart.length-1]);
 }

  
  
 onPaginate(event) {
  event.page=event.page+1
  this.pagination.current_page=event.page;
  this.loadReceiptServerByFilter(this.searchFilter,event.page);
}




}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/reseipts/receipt/receipt.component.ts